import { render, staticRenderFns } from "./seccionesTabla.vue?vue&type=template&id=b6b075f4"
import script from "./seccionesTabla.vue?vue&type=script&lang=js"
export * from "./seccionesTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports